(() => {
  'use strict';
  const root = document.getElementById('VelorelaWelcome');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const dialog = root.querySelector('dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const copy = JSON.parse(root.querySelector('[data-vwl-copy]').textContent);
  const key = 'velorela-welcome-offer-v1';
  const $ = selector => root.querySelector(selector);
  const storage = {
    get(name) { try { return localStorage.getItem(name); } catch { return null; } },
    set(name, value) { try { localStorage.setItem(name, value); } catch {} }
  };
  let state = { subscribed: false, step: 0 };
  try {
    const saved = JSON.parse(storage.get(key));
    if (saved && typeof saved === 'object') state = { subscribed: saved.subscribed === true, step: Math.max(0, Math.min(2, Number.isInteger(saved.step) ? saved.step : 0)) };
  } catch {}
  const success = !!$('[data-vwl-success="true"]');
  const hasErrors = !!$('#VwlFormMessage');
  if (success || root.dataset.subscribed === 'true') state.subscribed = true;
  if (success) state.step = 2;
  let busy = false;
  let revealedThisVisit = false;
  const finalIntro = $('[data-vwl-final-intro]').textContent;
  let rotation = 0;
  let giftWrite = null;
  const persist = () => storage.set(key, JSON.stringify(state));
  const clearFeedback = () => { $('[data-vwl-feedback]').textContent = ''; };
  function render() {
    const screen = root.dataset.existing === 'true' ? 'existing' : state.step < 2 ? 'play' : state.subscribed ? 'claimed' : 'signup';
    root.querySelectorAll('[data-vwl-screen]').forEach(el => { el.hidden = el.dataset.vwlScreen !== screen; });
    $('#VwlHeading').textContent = screen === 'existing' ? copy.existingHeading : screen === 'claimed' ? copy.ready : screen === 'signup' ? copy.claimHeading : copy.heading;
    $('[data-vwl-result-title]').textContent = state.step === 1 ? copy.firstTitle : copy.initialTitle;
    $('[data-vwl-result-text]').textContent = state.step === 1 ? copy.firstText : copy.initialText;
    $('[data-vwl-spin]').textContent = busy ? copy.spinning : state.step === 0 ? copy.spinFirst : copy.spinSecond;
    $('[data-vwl-spin]').disabled = busy;
    root.querySelectorAll('[data-vwl-dot]').forEach(el => { el.classList.toggle('is-done', Number(el.dataset.vwlDot) <= state.step || state.step === 2); });
    root.dataset.step = String(state.step);
    $('[data-vwl-gift]').hidden = state.step < 1;
    $('[data-vwl-discount]').hidden = state.step < 2;
    $('[data-vwl-reveal-image]').hidden = state.step !== 1 || screen !== 'play';
    $('[data-vwl-terms]').hidden = state.step < 2 || screen === 'existing';
    $('.vwl-note').textContent = state.step < 2 ? copy.note : copy.claimNote;
    if (screen === 'claimed') $('[data-vwl-final-intro]').textContent = revealedThisVisit || success ? finalIntro : copy.resume;
  }
  function open() {
    render();
    if (!dialog.open) dialog.showModal();
    try { sessionStorage.setItem(key + '-shown', 'true'); } catch {}
  }
  function close() {
    dialog.close();
    storage.set(key + '-dismissed', 'true');
    $('[data-vwl-open]').focus({ preventScroll: true });
  }
  function saveGiftRequest() {
    if (giftWrite) return giftWrite;
    const url = new URL('cart/update.js', new URL(root.dataset.root, location.origin));
    giftWrite = fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Welcome gift request': '1 gray press-to-inflate travel neck pillow', 'Welcome offer': 'WELCOME10: subscribed customer, first order only; verify before packing' } }),
      signal: AbortSignal.timeout(10000)
    }).then(response => { if (!response.ok) throw new Error('Unable to save gift request'); return response.json(); }).finally(() => { giftWrite = null; });
    return giftWrite;
  }
  $('[data-vwl-open]').hidden = false;
  $('[data-vwl-open]').addEventListener('click', open);
  $('[data-vwl-close]').addEventListener('click', close);
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } });
  document.addEventListener('click', event => { if (event.target.closest('[data-velorela-welcome-open]')) open(); });
  $('[data-vwl-spin]').addEventListener('click', () => {
    if (busy || root.dataset.existing === 'true' || state.step >= 2) return;
    clearFeedback();
    revealedThisVisit = true;
    busy = true;
    const sector = state.step === 0 ? 240 : 0;
    rotation = (Math.floor(rotation / 360) + 4) * 360 + (360 - sector) % 360;
    $('[data-vwl-wheel]').style.transform = 'rotate(' + rotation + 'deg)';
    render();
    const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 1550;
    setTimeout(() => {
      state.step = Math.min(2, state.step + 1);
      persist();
      busy = false;
      render();
      if (state.step === 2) $('#VwlHeading').scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }, duration);
  });
  $('[data-vwl-shop]').addEventListener('click', async () => {
    if (busy || root.dataset.existing === 'true' || !state.subscribed || state.step !== 2) return;
    const button = $('[data-vwl-shop]');
    busy = true;
    button.disabled = true;
    button.textContent = copy.saving;
    clearFeedback();
    try {
      await saveGiftRequest();
      const target = new URL('discount/WELCOME10', new URL(root.dataset.root, location.origin));
      target.searchParams.set('redirect', root.dataset.shopUrl);
      location.assign(target.href);
    } catch {
      $('[data-vwl-feedback]').textContent = copy.retry;
      button.disabled = false;
      button.textContent = copy.shop;
      busy = false;
    }
  });
  persist();
  render();
  if (success || hasErrors) open();
  else if (root.dataset.existing !== 'true' && root.dataset.designMode !== 'true' && !storage.get(key + '-dismissed') && state.step < 2 && !/\/(cart|account|pages)(\/|$)/.test(location.pathname)) {
    let shown = false;
    try { shown = sessionStorage.getItem(key + '-shown') === 'true'; } catch {}
    if (!shown) setTimeout(() => {
      const focused = document.activeElement;
      const interacting = focused && (focused.matches('input, textarea, select') || focused.isContentEditable);
      if (document.visibilityState !== 'visible' || interacting || document.querySelector('dialog[open], shopify-chat[open]')) return;
      open();
    }, 8000);
  }
})();

